"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function MethodSection() {
  return <section id="method" className="bg-background pt-0 pb-16 md:pb-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">

          <div className="order-2 lg:order-1">
            <img src="https://yotsuya-sc-room.com/wp-content/uploads/2026/10/compass-method.jpg" data-wvc-srcset="https://yotsuya-sc-room.com/wp-content/uploads/2026/10/compass-method.jpg-wvc-srcset" data-wvc-sizes="https://yotsuya-sc-room.com/wp-content/uploads/2026/10/compass-method.jpg-wvc-sizes" alt="窓際に置かれたコンパス、外からの光が淡く当たっている" className="w-full rounded-lg shadow-lg object-cover aspect-[4/3]" loading="lazy" />
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-block w-fit bg-primary text-primary-foreground text-sm font-bold px-3 py-1 rounded-sm mb-4">カウンセリングの方向性</span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">自分を深く知り、<br />他者を理解する<br />それが問題解決への糸口になる</h2>
            <Separator className="w-12 h-0.5 bg-primary mb-8" />
            <div className="space-y-6">
              <p className="text-foreground leading-relaxed font-default">悩みや困りごとを改善していこうとする時、まず大事なことは問題についてよく知ることです。自己に関する悩みであれば自分のことを、人との付き合い方に関する悩みであれば自分と相手の関係を。</p>
              <p className="text-foreground leading-relaxed font-default">問題について理解が深まることで状況をいろいろな観点から眺めることが出来るようになり、そこから自分がどう対応すればいいか考えがまとまっていきます。</p>
              <p className="text-foreground leading-relaxed font-default">当ルームでは、自分や他者、出来事についての理解を深めていきながら、問題の改善や解決の方法を見つけていくカウンセリングをメインに行っています。</p>
            </div>
            <div className="pt-8">
              <Button asChild variant="outline" size="lg" className="border-primary text-primary-heading hover:bg-primary/10 px-8 rounded-lg">
                <Link to="https://yotsuya-sc-room.com/method/">カウンセリングの方向性を見る</Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}